'use strict';exports.__esModule = true;exports.setCurrentPaginationStep = exports.deactivateProject = exports.myProject = undefined;var _axios = require('axios');var _axios2 = _interopRequireDefault(_axios);
var _reduxAct = require('redux-act');
var _reduxLoop = require('redux-loop');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var

promise = _reduxLoop.Effects.promise;

var myProject = (0, _reduxAct.createAction)('/MY_PROJECT');
var myProjectSuccess = (0, _reduxAct.createAction)('/MY_PROJECT_SUCCESS');
var myProjectFail = (0, _reduxAct.createAction)('/MY_PROJECT_FAIL');

var deactivateProject = (0, _reduxAct.createAction)('/DEACTIVATE_PROJECT');
var deactivateProjectSuccess = (0, _reduxAct.createAction)('/DEACTIVATE_PROJECT_SUCCESS');
var deactivateProjectFail = (0, _reduxAct.createAction)('/DEACTIVATE_PROJECT_FAIL');

var setCurrentPaginationStep = (0, _reduxAct.createAction)('/SET_CURRENT_PAGINATION_STEP');

var initialState = {
    data: null,
    loaded: false,
    loading: false,
    diaсtivatedProject: null,
    currentPaginationStep: 1 };


var fetchProjects = function fetchProjects(_ref) {var token = _ref.token;return (
        _axios2.default.get('/projects/my ', { headers: { access_token: token } }).
        then(myProjectSuccess, myProjectFail));};

var handleMyProject = function handleMyProject(state, data) {return (
        (0, _reduxLoop.loop)(Object.assign({}, state, { loaded: false, loading: true }), promise(fetchProjects, data)));};


var handleMyProjectSuccess = function handleMyProjectSuccess(state, _ref2) {var data = _ref2.data;return Object.assign({},
    state, {
        data: data,
        loaded: true,
        loading: false });};


var handleMyProjectFail = function handleMyProjectFail(state) {return Object.assign({},
    state, {
        loaded: true,
        loading: false,
        error: true });};


var fetchDeactivateProject = function fetchDeactivateProject(_ref3) {var isDeactivated = _ref3.isDeactivated,token = _ref3.token,id = _ref3.id,data = _ref3.data;return (
        _axios2.default.post('projects/' + (isDeactivated ? 'activate' : 'deactivate') + '/' + id, data, { headers: { access_token: token } }).
        then(deactivateProjectSuccess, deactivateProjectFail));};

var handleDeactivateProject = function handleDeactivateProject(state, data) {return (
        (0, _reduxLoop.loop)(Object.assign({}, state, { error: null }), promise(fetchDeactivateProject, data)));};

var handleDeactivateProjectSuccess = function handleDeactivateProjectSuccess(state, _ref4) {var data = _ref4.data;return Object.assign({},
    state, {
        diaсtivatedProject: data });};


var handleDeactivateProjectFail = function handleDeactivateProjectFail(state) {return Object.assign({},
    state, {
        error: true });};


var handleSetCurrentPaginationStep = function handleSetCurrentPaginationStep(state, action) {
    if (action !== 0) {
        return Object.assign({},
        state, {
            currentPaginationStep: action });

    }
    return Object.assign({},
    state, {
        currentPaginationStep: null });

};

var myProjects = (0, _reduxAct.createReducer)(function (on) {
    on(myProject, handleMyProject);
    on(myProjectSuccess, handleMyProjectSuccess);
    on(myProjectFail, handleMyProjectFail);

    on(deactivateProject, handleDeactivateProject);
    on(deactivateProjectSuccess, handleDeactivateProjectSuccess);
    on(deactivateProjectFail, handleDeactivateProjectFail);

    on(setCurrentPaginationStep, handleSetCurrentPaginationStep);
}, initialState);exports.


myProject = myProject;exports.
deactivateProject = deactivateProject;exports.
setCurrentPaginationStep = setCurrentPaginationStep;exports.default =


myProjects;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/myProjects.js
// module id = 1274
// module chunks = 0